/** Demo dashboard data — Issue #93 (client-side only, no API) */

export const DEMO_MODE_STORAGE_KEY = 'ahk-demo-mode';

export interface DemoClient {
  id: string;
  name: string;
  phone: string;
  document: string;
  created_at: string;
}

export const DEMO_CLIENTS: DemoClient[] = [
  { id: 'demo-1', name: 'Maria Fernanda', phone: '(11) 98888-1234', document: '123.456.789-00', created_at: new Date().toISOString() },
  { id: 'demo-2', name: 'Carlos Eduardo', phone: '(21) 97777-6543', document: '987.654.321-00', created_at: new Date().toISOString() },
  { id: 'demo-3', name: 'Helena Costa', phone: '(31) 96666-1122', document: '456.789.123-00', created_at: new Date().toISOString() },
  { id: 'demo-4', name: 'João Pedro', phone: '(41) 95555-7788', document: '852.741.963-00', created_at: new Date().toISOString() },
];

export const DEMO_SIMPLE_STATS = {
  totalAppointments: 128,
  completedToday: 6,
  completedThisMonth: 48,
  completionRate: 92,
  totalRevenue: 45200,
  monthlyRevenue: 18750,
  averageDuration: 115,
  timeDiscrepancies: {
    overTime: 2,
    underTime: 9,
    exactTime: 14,
    averageDifference: -12,
  },
};

export const DEMO_PROPERTIES_COUNT = 18;

export const DEMO_ADMIN_STATS = {
  totalClients: 47,
  totalRevenue: 45200,
  monthlyRevenue: 18750,
  totalAppointments: 128,
  completedToday: 6,
  completedThisMonth: 48,
  pendingPayments: 5,
  overduePayments: 2,
  completionRate: 92,
  cancellationRate: 4.2,
  averageTicket: 385.5,
  employeeRankings: [
    { id: 'demo-emp-1', name: 'Ana Silva', rating: 4.9, completed: 32 },
    { id: 'demo-emp-2', name: 'Bruno Lima', rating: 4.7, completed: 28 },
    { id: 'demo-emp-3', name: 'Carla Souza', rating: 4.6, completed: 24 },
    { id: 'demo-emp-4', name: 'Diego Alves', rating: 4.5, completed: 21 },
    { id: 'demo-emp-5', name: 'Elisa Rocha', rating: 4.4, completed: 18 },
  ],
  monthlyTrend: [
    { month: 'Dez/25', revenue: 14200, appointments: 98, completed: 88 },
    { month: 'Jan/26', revenue: 15800, appointments: 105, completed: 94 },
    { month: 'Fev/26', revenue: 16100, appointments: 112, completed: 99 },
    { month: 'Mar/26', revenue: 17200, appointments: 118, completed: 105 },
    { month: 'Abr/26', revenue: 18100, appointments: 122, completed: 110 },
    { month: 'Mai/26', revenue: 18750, appointments: 128, completed: 118 },
  ],
};

const today = new Date();
const todayStr = today.toISOString();

export const DEMO_EMPLOYEE_APPOINTMENTS = {
  today: [
    {
      id: 'demo-a1',
      client_name: 'Maria Fernanda',
      property_name: 'Apartamento Jardins',
      service_type: 'Limpeza completa',
      scheduled_date: todayStr,
      status: 'confirmed',
      duration: 120,
    },
    {
      id: 'demo-a2',
      client_name: 'Helena Costa',
      property_name: 'Casa Alphaville',
      service_type: 'Limpeza pós-obra',
      scheduled_date: todayStr,
      status: 'in_progress',
      duration: 180,
    },
  ],
  upcoming: [
    {
      id: 'demo-a3',
      client_name: 'João Pedro',
      property_name: 'Cobertura Moema',
      service_type: 'Manutenção semanal',
      scheduled_date: new Date(today.getTime() + 86400000).toISOString(),
      status: 'scheduled',
      duration: 90,
    },
  ],
  completedToday: 3,
};

export const DEMO_CLIENT_APPOINTMENTS = {
  upcoming: [
    {
      id: 'demo-c1',
      property_name: 'Meu apartamento',
      service_type: 'Limpeza completa',
      scheduled_date: new Date(today.getTime() + 2 * 86400000).toISOString(),
      status: 'confirmed',
      duration: 120,
    },
  ],
  recent: [
    {
      id: 'demo-c2',
      property_name: 'Meu apartamento',
      service_type: 'Limpeza express',
      scheduled_date: new Date(today.getTime() - 7 * 86400000).toISOString(),
      status: 'completed',
      duration: 90,
      actual_duration: 85,
    },
    {
      id: 'demo-c3',
      property_name: 'Casa de praia',
      service_type: 'Limpeza profunda',
      scheduled_date: new Date(today.getTime() - 21 * 86400000).toISOString(),
      status: 'completed',
      duration: 240,
      actual_duration: 230,
    },
  ],
  totalServices: 12,
};

export function readDemoModeFromStorage(): boolean {
  if (typeof window === 'undefined') return false;
  return localStorage.getItem(DEMO_MODE_STORAGE_KEY) === 'true';
}

export function writeDemoModeToStorage(enabled: boolean): void {
  if (typeof window === 'undefined') return;
  localStorage.setItem(DEMO_MODE_STORAGE_KEY, enabled ? 'true' : 'false');
}
